import React from "react";
import PropTypes from "prop-types";
import Timeago from "react-timeago";
import { CollectionName } from "../../Atoms/CollectionName";
import { LoadmoreButton } from "../../Atoms/Loadmore";
import { formatter, getTextColor } from "../../../utils/utils";
import "./magazine-cards.m.css";
import { StateProvider } from "../../SharedContext";
import { MagazineCoverImageCard } from "../../Atoms/MagazineCoverImage";

const MagazineHeaderCard = ({ collection = {}, config = {} }) => {
  const { "created-at": createdAt, summary } = collection;
  const { theme = "" } = config;
  const textColor = getTextColor(theme);

  return (
    <div className="full-width-with-padding arrow-component" style={{ backgroundColor: theme }}>
      <div className="arr-magazine-card" styleName="magazine-header intro-button">
        <MagazineCoverImageCard collection={collection} config={config} />
        <div styleName="content">
          <div styleName={`time ${textColor}`}>
            <Timeago date={createdAt} formatter={formatter} />
          </div>
          <CollectionName collection={collection} />
          <div styleName={`summary ${textColor}`}>{summary}</div>
          <LoadmoreButton collection={collection} template="customUrlPath" />
        </div>
      </div>
    </div>
  );
};

MagazineHeaderCard.propTypes = {
  collection: PropTypes.shape({
    "created-at": PropTypes.number,
    summary: PropTypes.string,
    items: PropTypes.array
  }),
  config: PropTypes.shape({ theme: PropTypes.string, footerButton: PropTypes.string })
};

export default StateProvider(MagazineHeaderCard);
